import { useState } from 'react'

import NiceModal from '@ebay/nice-modal-react'
import { TextInput } from '@mantine/core'

import { ModalShell, useModalControls } from '#components/Modals'
import { FormError } from '#components/Onboarding/FormErrors'
import { PasswordInput } from '#components/PasswordInput'
import { useMst } from '#state'

type ModalParams = {
  onVerified?: Callback
}

// oxlint-disable-next-line react/only-export-components
const VerifyPassword = ({ onVerified }: ModalParams) => {
  const controls = useModalControls()
  const mst = useMst()
  const [password, setPassword] = useState('')
  const { email } = mst.user

  const verify = async () => {
    controls.setLoading(true)
    const opts = { email, password }
    const result = await mst.authManager.stytch.authenticateWithPassword(opts)

    if (result.success) {
      onVerified?.()
      controls.onClose()
    } else {
      controls.setLoading(false)
      controls.setErrorMessage(<FormError code={result.code} />)
    }
  }

  return (
    <ModalShell
      title="Verify current password"
      opened={controls.opened}
      onClose={controls.onClose}
      size="sm"
      confirmLabel="Submit"
      onConfirm={verify}
      errorMessage={controls.errorMessage}
    >
      {/* purely for accessibility https://goo.gl/9p2vKq */}
      <TextInput
        type="email"
        value={email}
        autoComplete="username"
        hidden
        readOnly
      />
      <PasswordInput
        autoComplete="current-password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
    </ModalShell>
  )
}

const VerifyPasswordModal = NiceModal.create(VerifyPassword)

// See (./readme.md)
export const showVerifyPasswordModal = (args?: ModalParams) =>
  NiceModal.show(VerifyPasswordModal, args)
